export default __webpack_public_path__ + "static/media/photo 11.242b887e.jpg";